import { storableError } from '../util/errors';
import { denormalisedResponseEntities } from '../util/data';
import { fetchCurrentUser, currentUserShowSuccess } from './user.duck';

// ================ Action types ================ //

export const VERIFICATION_REQUEST = 'app/EmailVerification/VERIFICATION_REQUEST';
export const VERIFICATION_SUCCESS = 'app/EmailVerification/VERIFICATION_SUCCESS';
export const VERIFICATION_ERROR = 'app/EmailVerification/VERIFICATION_ERROR';

export const CHANGE_EMAIL_REQUEST = 'app/EmailVerification/CHANGE_EMAIL_REQUEST';
export const CHANGE_EMAIL_SUCCESS = 'app/EmailVerification/CHANGE_EMAIL_SUCCESS';
export const CHANGE_EMAIL_ERROR = 'app/EmailVerification/CHANGE_EMAIL_ERROR';
export const CHANGE_EMAIL_CLEAR = 'app/EmailVerification/CHANGE_EMAIL_CLEAR';

// ================ Reducer ================ //

const initialState = {
  isVerified: false,

  // verification
  verificationError: null,
  verificationInProgress: false,

  // change email
  changeEmailInProgress: false,
  changeEmailError: null,
  changeEmailSuccess: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case VERIFICATION_REQUEST:
      return {
        ...state,
        verificationInProgress: true,
        verificationError: null,
      };
    case VERIFICATION_SUCCESS:
      return { ...state, verificationInProgress: false, isVerified: true };
    case VERIFICATION_ERROR:
      return { ...state, verificationInProgress: false, verificationError: payload };

    case CHANGE_EMAIL_REQUEST:
      return {
        ...state,
        changeEmailInProgress: true,
        changeEmailError: null,
        changeEmailSuccess: false,
      };
    case CHANGE_EMAIL_SUCCESS:
      return { ...state, changeEmailInProgress: false, changeEmailSuccess: true };
    case CHANGE_EMAIL_ERROR:
      return { ...state, changeEmailInProgress: false, changeEmailError: payload };
    case CHANGE_EMAIL_CLEAR:
      return {
        ...state,
        changeEmailInProgress: false,
        changeEmailError: null,
        changeEmailSuccess: false,
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

export const verificationInProgress = state => {
  return state.EmailVerification.verificationInProgress;
};

// ================ Action creators ================ //

export const verificationRequest = () => ({ type: VERIFICATION_REQUEST });
export const verificationSuccess = () => ({ type: VERIFICATION_SUCCESS });
export const verificationError = error => ({
  type: VERIFICATION_ERROR,
  payload: error,
  error: true,
});

export const changeEmailRequest = () => ({ type: CHANGE_EMAIL_REQUEST });
export const changeEmailSuccessAction = () => ({ type: CHANGE_EMAIL_SUCCESS });
export const changeEmailErrorAction = error => ({
  type: CHANGE_EMAIL_ERROR,
  payload: error,
  error: true,
});
export const changeEmailClear = () => ({ type: CHANGE_EMAIL_CLEAR });

// ================ Thunks ================ //

export const verify = verificationToken => (dispatch, getState, sdk) => {
  if (verificationInProgress(getState())) {
    return Promise.reject(new Error('Email verification already in progress'));
  }
  dispatch(verificationRequest());

  // Note that the thunk does not reject when the verification fails, it
  // just dispatches the login error action.
  return sdk.currentUser
    .verifyEmail({ verificationToken })
    .then(() => dispatch(verificationSuccess()))
    .then(() => dispatch(fetchCurrentUser()))
    .catch(e => dispatch(verificationError(storableError(e))));
};

export const changeEmail = ({ email, currentPassword }) => (dispatch, getState, sdk) => {
  dispatch(changeEmailRequest());

  return sdk.currentUser
    .changeEmail(
      { email, currentPassword },
      {
        expand: true,
        include: ['profileImage'],
        'fields.image': ['variants.square-small', 'variants.square-small2x'],
      }
    )
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the sdk.currentUser.changeEmail response');
      }
      const currentUser = entities[0];
      dispatch(currentUserShowSuccess(currentUser));
      dispatch(changeEmailSuccessAction());
    })
    .catch(e => {
      dispatch(changeEmailErrorAction(storableError(e)));
    });
};
